export default "__VITE_ASSET__CbHuAXBD__"